import { isDefined } from '../utils/type';

export const INCOME_SOURCE_OPTIONS = {
  'alimony/child_support': 'Alimony/Child Support Income',
  employed: 'Employed',
  other: 'Other',
  retired_benefits: 'Retirement Income (401k, pension, etc.)',
  self_employed: 'Self-Employed',
  'social_security/disability_income': 'Social Security/Disability Income',
  unemployment_benefits: 'Unemployment Benefits',
} as const;
export type IncomeSourceValueT = keyof typeof INCOME_SOURCE_OPTIONS;
export type IncomeSourceLabelT = typeof INCOME_SOURCE_OPTIONS[IncomeSourceValueT];

export const employedIncomeSources: IncomeSourceValueT[] = ['employed', 'self_employed'];
export const benefitsIncomeSources: IncomeSourceValueT[] = [
  'alimony/child_support',
  'retired_benefits',
  'social_security/disability_income',
  'unemployment_benefits',
  'other',
];

export type BenefitsWillExpireValueT = 'yes' | 'no';

export const isEmployed = (incomeSource?: IncomeSourceValueT): boolean => (
  isDefined(incomeSource) && employedIncomeSources.includes(incomeSource)
);

export const isBenefitsIncomeSource = (incomeSource?: IncomeSourceValueT): boolean => (
  isDefined(incomeSource) && benefitsIncomeSources.includes(incomeSource)
);

export type IncomeSourceOptionT = {
    label: IncomeSourceLabelT;
    value: IncomeSourceValueT;
};

export const incomeSourceOptions: IncomeSourceOptionT[] = (Object
  .entries(INCOME_SOURCE_OPTIONS) as [IncomeSourceValueT, IncomeSourceLabelT][])
  .map(([value, label]) => ({ label, value }));

export type IncomeSourceFormT = {
  amount?: number;
  benefits?: {
    expiration?: string;
    willExpire?: BenefitsWillExpireValueT;
  };
  employment?: {
    employer: string;
    phoneNumber: string;
    title: string;
  };
  source?: IncomeSourceValueT;
};
